export default __webpack_public_path__ + "assets/b3b1be3022a34b6e68bd550daaa48aed.svg";